import { DeliveryInformation, OrderingInformation } from '@next/core-lib/cart';

import { GetMultipleProductDeliveryDatesWith0FlexibilityResponse } from '../product/models/product-delivery-moment.models';

export const calculateDeliveryInformation = (
  proposalDeliveryMoments: GetMultipleProductDeliveryDatesWith0FlexibilityResponse,
  skuId: number,
  orderingInformation?: OrderingInformation,
): DeliveryInformation => {
  const flexibility = orderingInformation?.useFixedFlexibility ? 0 : orderingInformation?.flexibility;
  const proposedDeliveryMoments = proposalDeliveryMoments.deliveryDates.find((moment) => moment.skuId === skuId);
  if (!proposedDeliveryMoments) {
    return {
      deliveryDate: undefined!,
      flexibility: flexibility,
    };
  }
  const deliveryDate = proposedDeliveryMoments.proposedDate;

  let possibleDeliveryDays: string[];
  if (!flexibility || flexibility == 0) {
    possibleDeliveryDays = [deliveryDate];
  } else {
    const zeroFlexDeliveryMoments = proposalDeliveryMoments.zeroFlexibilityDeliveryDates.find((moment) => moment.skuId === skuId);
    const indexOfDeliveryDate = zeroFlexDeliveryMoments.deliveryDates.findIndex((moment) => moment === deliveryDate);
    const indexOfFirstFlexibilityDate = indexOfDeliveryDate - flexibility;
    possibleDeliveryDays = zeroFlexDeliveryMoments.deliveryDates.slice(indexOfFirstFlexibilityDate, indexOfDeliveryDate + 1);
  }

  return {
    deliveryDate: deliveryDate,
    flexibility: flexibility,
    possibleDeliveryDays: possibleDeliveryDays,
  };
};
